import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageWrapper from '../layouts/Index';
import PageTitle from '../components/PageTitle';
import {fetchBundleByDeviceId, submitCustomerBundle, fetchAODF2BundlesByDeviceId, submitAODF2CustomerBundle } from "../services/oxygenRetailServices";
import { useDispatch, useSelector } from 'react-redux';
import OxygenDeviceBundleCard from '../components/OxygenDeviceBundleCard';
import { hideModal, setShowModal } from '../redux/features/oxygen/customModalSlice';
import useCustomAlert from '../components/Alert2';
import { setOtpLoading } from '../redux/features/oxygen/oxygenRetailSlice';
import { updatePrecustomer } from '../redux/features/precustomers/PrecustomerSlice';
import { updateCustomerOnboardingStat } from '../services/PrequalificationService';

const OxygenDeviceBundles = () => {
    const dispatch = useDispatch();
    const customAlert = useCustomAlert();
    const navigate = useNavigate();
    const [deviceBundles, setDeviceBundles] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const deviceId = useSelector((state) => state?.oxygenRetail?.selectedDevice?.id);
    const precustomer =  useSelector((state) => state?.precustomer?.precustomerData.precustomer);
    const financierID = localStorage.getItem("allAboard-financierid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-financierid"));
    const userId = useSelector((state) => state?.user?.user?.id);
    const deviceType_id = localStorage.getItem("device_type_id") !== "undefined" && JSON.parse(localStorage.getItem("device_type_id"));
    const partnerId = localStorage.getItem("allAboard-partnerid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-partnerid"));
    const eligibleAmount = precustomer?.eligibleAmount;
    const creditLimit = precustomer?.creditLimit;
    const amount = eligibleAmount || creditLimit;
    console.log("eligible amount:", amount);


    const handleFetchBundleByDeviceId = async() => {
        setLoading(true);
        let response;
        const payload ={ 
            mssidn: String(precustomer?.msisdn), 
            device_type_id: Number(financierID) === 20 || Number(partnerId) === 409 ? 0 : Number(deviceId) || Number(precustomer?.bundled_device_type_id)  || Number(deviceType_id) , 
            financier_id: String(financierID), 
            store_id: 0,
            precustomer_id: Number(financierID) === 20 || Number(partnerId) === 409 ? Number(precustomer?.precustomerId) : 0, 
            credit_limit: "", 
            useMinCreditLimit: Number(partnerId) === 407 ? false : true, 
            repId: Number(userId),
        }
        if (Number(financierID) === 14 || Number(partnerId) === 408){
            response = await fetchBundleByDeviceId(payload);
        }else if (Number(financierID) === 20 || Number(partnerId) === 409){
            response = await fetchAODF2BundlesByDeviceId(payload);
        }
        console.log("response", response);
        if(response?.status === true) {
            setLoading(false);
            setDeviceBundles(response?.data);
        }else{
            setLoading(false);
            customAlert.showToast("error", `${response?.message}` || "Failed to fetch device bundles..!");
            setErrorMessage(response?.message || "Failed to fetch device bundles..!");
        }
    }

    useEffect(() => {
        handleFetchBundleByDeviceId();
    }, [deviceId]);

    const handleSelectBundle = (bundle, device_type_id) => {
        dispatch(setShowModal({
            status:true,
            title:"Are you Sure you want to proceed with this bundle ?",
            type:"confirmBundle",
            showCloseButton:false,
            data:{bundle, device_type_id, onClick:handleSubmitBundle},
        }));
    }

    const handleSubmitBundle = async(bundle, device_type_id) => {
        dispatch(setOtpLoading(true));
        console.log("bundle modal:", bundle, device_type_id);
        let res;
        dispatch(updatePrecustomer({
            precustomer: {
                ...precustomer,
                precustomerId: Number(financierID) === 20 || Number(partnerId) === 409 ? Number(precustomer?.precustomerId) : deviceBundles?.preCustomer_id, 
            },
        }));
        const payload= {
            deviceOptionId: String(bundle?.id),
            bundleDeviceTypeId: Number(financierID) === 20 || Number(partnerId) === 409 ? "0" : String(device_type_id) || String(precustomer?.bundled_device_type_id),
            down_payt: String(bundle?.down_payt),
            equityContribution: String(bundle?.equity_contribution) || "0",
            preCustomerId: Number(deviceBundles?.preCustomer_id) || Number(precustomer?.precustomerId),
            repId: Number(userId),
            isSelfOnboard: false
        }
        
        if (Number(financierID) === 14 || Number(partnerId) === 408){
            res = await submitCustomerBundle(payload);
        }else if (Number(financierID) === 20 || Number(partnerId) === 409){
            res = await submitAODF2CustomerBundle(payload);
        }
        console.log("submit-bundle res:", res);
        
        if(res?.status === true) {
            dispatch(setOtpLoading(false));
            // Make api call to update the onboarding status 
            await updateCustomerOnboardingStat(
                precustomer?.msisdn,
                "BUNDLE_SELECTED"
            );
            customAlert.showToast("success", `${res?.message}` || `Bundle submitted successfully`);
            dispatch(hideModal());

            if(Number(financierID) === 20 || Number(partnerId) === 409){
                // go to kyc
                const updateStore = dispatch(
                    updatePrecustomer({
                        ...precustomer,
                        onboarding_status: "kyc",
                    })
                );
            
                if (updateStore) {
                    return navigate("/kyc"); 
                }
            }else{
                // go to liveness check
                dispatch(updatePrecustomer({
                    precustomer: {
                        ...precustomer, 
                    },
                    onboarding_status: "liveness-check",
                }));
                navigate("/liveness-check"); 
                
            }
        }else{
            dispatch(setOtpLoading(false));
            customAlert.showToast("error", `${res?.message}` || "Failed to submit bundle..!");
        }
    }

  return (
    <PageWrapper>
        <PageTitle title={`Device Bundle`} />

        {loading ? (
            <p className='text-center'>Fetching device bundles...</p>
        ):errorMessage ? (
            <div className="alert alert-danger" role="alert">
            {errorMessage}
        </div>
        ):(
            <>
            {
            Number(financierID) !== 20 || Number(partnerId) !== 409 ? (
                <>
                <div className="d-flex justify-content-end gap-3 mt-6 mb-6">
                    <button className="btn btn-primary" onClick={() => navigate(`/oxygen-devices?amount=${amount}`)}>Choose a New Device</button>
                </div>
                <OxygenDeviceBundleCard data={deviceBundles} onClick={handleSelectBundle} /> 
                </>
            ):(
                <>
                    {Array.isArray(deviceBundles) && deviceBundles?.map((deviceBundle, index) => (
                    <OxygenDeviceBundleCard 
                        key={index} 
                        data={deviceBundle} 
                        onClick={handleSelectBundle} 
                    /> 
                    ))}
                </>
            )
            }
            </>
        )
        
        }

    </PageWrapper>
  )
}

export default OxygenDeviceBundles;